<template>
  <div class="expertise-section">
    <h2 class="section-title"><i class="fas fa-briefcase"></i> Expertise</h2>
    <div class="section-card">
      <p class="expertise-content">{{ expertise || 'No expertise information available.' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstructorExpertise',
  props: {
    expertise: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.expertise-section {
  margin-bottom: 2rem;
}

.section-title {
  margin: 0 0 1.25rem;
  color: #1e293b;
  font-size: 1.375rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.section-title i {
  color: #3b82f6;
  font-size: 1.25rem;
}

.section-card {
  background: white;
  padding: 1.5rem;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 0.5rem;
}

.expertise-content {
  color: #475569;
  line-height: 1.6;
  margin: 0;
}
</style> 